export default "__VITE_ASSET__W1Pi9ZVl__"